var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3707"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52",
    cx: 11,
    cy: 11,
    r: 9.45455,
    fill: "#08BD80",
    stroke: "#C9FDEB",
    strokeWidth: 2.90909
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M14.4749 8.52137C14.2197 8.27055 13.806 8.27055 13.5508 8.52137L9.86524 12.1437L8.44751 10.7566C8.19173 10.5064 7.77798 10.5073 7.52336 10.7587C7.26874 11.0101 7.26968 11.4167 7.52546 11.667L9.37796 13.4795C9.57084 13.6682 9.85357 13.7141 10.0901 13.6174C10.1976 13.5893 10.2992 13.5338 10.3835 13.451L14.4749 9.42968C14.7301 9.17886 14.7301 8.77219 14.4749 8.52137Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.1b4ab90900fbd62a1ee3bb5bfed42da5.svg";
export { ForwardRef as ReactComponent };